const styles = {
  mainContainer: {
    boxSizing: "border-box",
    fontFamily: "sans-serif",
    width: "100%",

    border: "1px solid black",
  },
  contentContainer: {
    display: "flex",
  },
  logoStyles: {
    container: {
      display: "flex",
      flexDirection: "row",
      flexWrap: "wrap",
      justifyContent: "center",
      alignItems: "center",
      marginTop: "1rem",
    },
    centerText: {
      borderBottom: "2px solid #333",
      paddingBottom: "2px",
      textAlign: "center",
      margin: 0,
      fontFamily: "sans-serif",
    },
    leftLogo: {
      maxWidth: "90px",
      maxHeight: "70px",
    },
    rightLogo: {
      maxWidth: "105px",
      maxHeight: "90px",
    },
    description: {
      fontSize: "13px",
      margin: 0,
    },
  },
  logoSection: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    borderRight: "1px solid black",
    flex: 7,
  },
  label: {
    margin: "0",
  },
  payeeStyles: {
    fontWeight: "bold",
    fontSize: "20px",
  },
  joPayeeStyles: {
    fontWeight: "bold",
    fontSize: "13px",
  },
  joAddressStyles: {
    fontSize: "13px",
    fontWeight: "normal",
  },
  disbursementLbl: {
    margin: "1rem 0 10px 0",
  },
  dateLbl: {
    borderTop: "1px solid black",
    borderBottom: "1px solid black",
  },
  sec1Lbl: {
    width: "100%",
    padding: "5px 5px 5px 10px",
    boxSizing: "border-box",
    fontSize: "12px",
    fontWeight: "bold",
  },
  metaInfoSection1: {
    flex: 3,
  },
  metaInfoSection2: {
    display: "flex",
    fontSize: "12px",
    borderTop: "1px solid black",
    width: "100%",
  },
  modeOfPayment: {
    padding: "10px",
    display: "flex",
    justifyContent: "center",
    alignItems: "flex-start",
    borderRight: "1px solid black",
    flex: 2,
  },
  checkboxSection: {
    padding: "10px",
    display: "flex",
    justifyContent: "space-around",
    alignItems: "flex-start",
    flex: 8,
  },
  payeeDetailsSec1: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "stretch",
    flexDirection: "column",
    padding: "7px",
    borderRight: "1px solid black",
    flex: 2,
  },
  payeeDetailsSec2: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    flex: 8,
  },
  employeeSec1: {
    display: "flex",
    justifyContent: "center",
    alignItems: "stretch",
    width: "100%",
  },

  employeeSec2: {
    display: "flex",
    justifyContent: "center",
    alignItems: "stretch",
    width: "100%",
    borderTop: "1px solid black",
  },
  payeeSec: {
    textAlign: "center",
  },
  addressSec: {
    textAlign: "center",
  },
  employeeNameSec: {
    flex: 7,
    padding: "10px",
    display: "flex",
    alignItems: "center",
    borderRight: "1px solid black",
  },
  accountNumSec: {
    flex: 7,
    padding: "10px",
    display: "flex",
    alignItems: "center",
  },
  tinSec: {
    flex: 3,
    padding: "5px 0  0 5px",
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "left",
  },

  metaInfoSection3: {
    display: "flex",
    fontSize: "12px",
    borderTop: "1px solid black",
    width: "100%",
  },
  headersRowLbl: {
    display: "flex",
    flexDirection: "row",
    textAlign: "center",
    width: "100%",
  },
  particularsLbl: {
    width: "60%",
    padding: "5px",
    borderRight: "1px solid black",
  },
  responsibilityLbl: {
    width: "18%",
    padding: "5px",
    borderRight: "1px solid black",
  },
  mofLbl: {
    width: "11%",
    padding: "5px",
    borderRight: "1px solid black",
  },
  amountLbl: {
    fontWeight: "bold",
    padding: "5px",
    width: "11%",
  },
  metaInfoSection4: {
    display: "flex",
    fontSize: "12px",
    borderTop: "1px solid black",
    width: "100%",
  },
  particularsContent: {
    width: "60%",
    display: "flex",
    textAlign: "left",
    flexDirection: "column",
    padding: "5px",
    borderRight: "1px solid black",
  },
  particularsSubContent: {
    boxSizing: "border-box",
    padding: "20px",
  },
  spanContainer: {
    textAlign: "left",
    paddingLeft: "10px",
    lineHeight: "1.5",
  },
  spanBlankSec: {
    borderBottom: "1px solid black",
    padding: "0 20px",
    fontWeight: "bold",
    fontSize: "10px",
  },
  attachmentSec: {
    marginTop: "20px",
  },
  attachContainer: {
    display: "flex",
  },
  sec_1: {
    flex: 5,
  },
  sec_2: {
    flex: 5,
    fontSize: "10px",
    textAlign: "center",
    padding: "3px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "flex-end",
  },
  certificationLbl: {
    fontWeight: "bold",
  },
  payeeDiv: {
    paddingTop: "2px",
    marginTop: "20px",
    borderTop: "1px solid black",
  },
  metaInfoSection5: {
    display: "flex",
    fontSize: "12px",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    borderTop: "1px solid black",
    width: "100%",
  },
  certifiedRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    width: "100%",
  },

  buttonSec: {
    fontSize: "12px",
  },
  certifiedLbl: {
    paddingLeft: "10px",
    fontWeight: "bold",
  },
  signatureSec: {
    margin: "20px 0 10px 0",
    textAlign: "center",
    borderTop: "1px solid black",
    width: "40%",
  },
  metaInfoSection6: {
    display: "flex",
    fontSize: "12px",
    flexDirection: "column",
    borderTop: "1px solid black",
    width: "100%",
  },
  tableContainer: {
    borderTop: "1px solid black",
    textAlign: "left",
    width: "100%",
    padding: "0",
    margin: "0",
    borderCollapse: "collapse",
  },
  accountTitleLbl: {
    width: "58%",
    borderRight: "1px solid black",
    padding: "3px",
  },
  uascsLbl: {
    width: "18%",
    borderRight: "1px solid black",
    padding: "3px",
  },
  debitLbl: {
    width: "12%",
    borderRight: "1px solid black",
    padding: "3px",
  },
  creditLbl: {
    width: "12%",
    padding: "3px",
  },
  theadSec: {
    borderBottom: "1px solid black",
  },
  evenRow: {
    backgroundColor: "#f2f2f2",
  },
  metaInfoSection7: {
    display: "flex",
    fontSize: "12px",
    flexDirection: "row",
    borderTop: "1px solid black",
    width: "100%",
  },
  certifiedSec: {
    borderBottom: "1px solid black",
    borderRight: "1px solid black",
    flex: 5,
  },
  checkboxContainer: {
    margin: "5px 0 5px 10px",
    display: "flex",
    boxSizing: "border-box",
    flexDirection: "column",
  },
  amountHolderSec: {
    boxSizing: "border-box",
    padding: "5px",
    textAlign: "center",
  },
  metaInfoSection8: {
    display: "flex",
    fontSize: "12px",
    flexDirection: "row",
    width: "100%",
  },
  signatureSec1: {
    display: "flex",
    width: "100%",
    borderRight: "1px solid black",
    flex: 5,
  },
  signatureSec2: {
    display: "flex",
    width: "100%",
    flex: 5,
  },
  signBlockContainer: {
    display: "flex",
    boxSizing: "border-box",
    padding: "5px",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "space-around",
    borderRight: "1px solid black",
    flex: 2,
  },
  authorizedPersonnelSec: {
    display: "flex",
    boxSizing: "border-box",
    padding: "25px 5px 5px  5px",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: "1px",
    flex: 8,
  },
  metaInfoSection9: {
    display: "flex",
    fontSize: "12px",
    borderTop: "1px solid black",
  },
  dateBlock1: {
    flex: 5,
    padding: "5px",
    borderRight: "1px solid black",
  },
  dateBlock2: {
    flex: 5,
    padding: "5px",
  },
  metaInfoSection10: {
    display: "flex",
    fontSize: "12px",
    borderTop: "1px solid black",
  },
  recipientSec: {
    flex: 9,
    width: "100%",
    borderRight: "1px solid black",
  },
  adaSec: {
    display: "flex",
    width: "100%",
    borderTop: "1px solid black",
  },
  checkSec: {
    width: "11.5%",
    borderRight: "1px solid black",
    padding: "5px",
  },
  blankSec: {
    width: "19.5%",
    borderRight: "1px solid black",
    padding: "5px",
  },
  dateSec: {
    width: "25%",
    borderRight: "1px solid black",
    padding: "5px",
  },
  bankNameSec: {
    width: "45%",
    padding: "5px",
  },
  jevSec: {
    flex: 1,
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    justifyContent: "space-around",
    width: "25%",
  },
  jevLbl: {
    borderBottom: "1px solid black",
    paddingLeft: "5px",
    boxSizing: "border-box",
    display: "flex",
    alignItems: "center",
    width: "100%",
    height: "50%",
  },
  jevDateLbl: {
    display: "flex",
    paddingLeft: "5px",
    boxSizing: "border-box",
    alignItems: "center",
    height: "50%",
    width: "100%",
  },
  officialSec: {
    padding: "5px",
  },
  metaInfoSection11: {
    width: "60%",
    display: "flex",
    padding: "10px 10px 10px 20px",
    fontSize: "12px",
    flexDirection: "column",
    fontFamily: "sans-serif",
    border: "1px solid black",
    pageBreakBefore: "always",
    breakBefore: "page",
  },
  computationSection: {
    marginTop: "10px",
    marginLeft: "15px",
  },
  divSecStyles: {
    marginTop: "30px",
    fontStyle: "italic",
    fontWeight: "bold",
    display: "flex",
    justifyContent: "space-between",
    padding: "5px 10px",
  },
  hasMargin: {
    marginTop: "30px",
  },
  divSecStyles1: {
    display: "flex",
    fontStyle: "italic",
    fontWeight: "bold",
    justifyContent: "space-between",
    width: "100%",
  },
  childEqualWidth: {
    flex: 1,
    textAlign: "center",
  },
  totalAmntEarned: {
    borderTop: "1px solid black",
    boxSizing: "border-box",
    padding: "5px 10px",
  },
  totalAmnt: {
    padding: "5px 10px",
    boxSizing: "border-box",
  },
};

export default styles;
